import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-85fe21d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-authorization-panel" }
const _hoisted_2 = { class: "mb-6" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "alert alert-info d-flex align-items-center py-2 px-3 my-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-7" }, [
    /*#__PURE__*/_createTextVNode(" Vai trò "),
    /*#__PURE__*/_createElementVNode("strong", null, "nguoi-dung"),
    /*#__PURE__*/_createTextVNode(" là vai trò cơ bản, được gán tự động cho mọi người dùng và không thể gỡ bỏ. ")
  ])
], -1))
const _hoisted_4 = { class: "row g-2" }
const _hoisted_5 = {
  key: 0,
  class: "text-muted fs-7"
}
const _hoisted_6 = {
  key: 0,
  class: "text-muted fw-normal fs-7"
}
const _hoisted_7 = { class: "permission-grid" }
const _hoisted_8 = { class: "row g-2" }
const _hoisted_9 = {
  key: 0,
  class: "text-muted fs-7"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LabelCustom = _resolveComponent("LabelCustom")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_LabelCustom, { "is-bolder": "" }, {
        default: _withCtx(() => [
          _createTextVNode("Vai trò (Roles)")
        ]),
        _: 1
      }),
      _hoisted_3,
      _createVNode(_component_el_checkbox_group, {
        modelValue: _ctx.selectedRolesModel,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedRolesModel) = $event)),
        disabled: !_ctx.canManage || _ctx.saving,
        onChange: _ctx.onRolesChange
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roleOptions, (role) => {
              return (_openBlock(), _createElementBlock("div", {
                key: role.id,
                class: "col-12 col-md-6 col-lg-4"
              }, [
                _createVNode(_component_el_checkbox, {
                  label: role.name
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(role.name), 1)
                  ]),
                  _: 2
                }, 1032, ["label"])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "disabled", "onChange"]),
      (!_ctx.roleOptions.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Không có vai trò khả dụng "))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_LabelCustom, { "is-bolder": "" }, {
        default: _withCtx(() => [
          _createTextVNode(" Quyền (Permissions) "),
          (_ctx.totalPermissionCount)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, " — " + _toDisplayString(_ctx.totalPermissionCount) + " quyền ", 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_el_checkbox_group, {
        modelValue: _ctx.selectedPermissionsModel,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedPermissionsModel) = $event)),
        disabled: !_ctx.canManage || _ctx.saving,
        class: "permission-checkbox-group",
        onChange: _ctx.onPermissionsChange
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_collapse, {
            modelValue: _ctx.expandedGroups,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.expandedGroups) = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.permissionGroups, (group) => {
                return (_openBlock(), _createBlock(_component_el_collapse_item, {
                  key: group.group,
                  name: group.group,
                  title: _ctx.groupTitle(group)
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.permissions, (permission) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: permission.id,
                            class: "col-12 col-md-6 col-lg-4"
                          }, [
                            _createVNode(_component_el_checkbox, {
                              label: permission.name
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(permission.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["label"])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _: 2
                }, 1032, ["name", "title"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["modelValue", "disabled", "onChange"]),
      (!_ctx.permissionGroups.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Không có quyền khả dụng "))
        : _createCommentVNode("", true)
    ])
  ]))
}